import { UnitValueBalance } from "@/models/consumption/unit-value-balance"
import {
    convertCentsToEuros,
    convertBytesToGigabytes,
    convertSecondsToHoursMinutesSecond,
    convertSecondsToMinutes,
    percentageHelper
} from "@/mega-ui/helpers/function"
import { IHourMinuteSecond, IConsumedType } from "@/interface"
import { ConsumptionSummaryTypeEnum, ConsumptionDataColorEnum }  from "@/enums"
import { getProductStore } from "@/helpers/storeHelpers"

const dataUnlimited = [100, 100];

const consumedData = (item: UnitValueBalance): IConsumedType => {
    const productStore = getProductStore();
    const excludingSub = convertBytesToGigabytes(item.value)-item.balanceValue;

    return {
        consumed: convertBytesToGigabytes(item.value),
        backgroundColor: [ConsumptionDataColorEnum.DATA, ConsumptionDataColorEnum.NEUTRE],
        data: item.balanceValue === 0 ? dataUnlimited : [ percentageHelper(convertBytesToGigabytes(item.value), item.balanceValue), 100],
        excludingSubscription: excludingSubscriptionMoreZero(excludingSub),
        overSpent: convertCentsToEuros(item.overspentValue ?? 0),
        unlimited: item.balanceValue === 0,
        base: item, 
        included: productStore?.volume?.data ?? 0,
        options: productStore?.volumeOptions?.data ?? 0
    }
}

const consumedCall = (item: UnitValueBalance): IConsumedType => {
    const productStore = getProductStore();
    const time: IHourMinuteSecond = convertSecondsToHoursMinutesSecond(item.value);
    const excludingSub = convertSecondsToMinutes(item.value)-convertSecondsToMinutes(item.balanceValue);

    return {
        consumed: time,
        backgroundColor: [ConsumptionDataColorEnum.CALL, ConsumptionDataColorEnum.NEUTRE],
        data: item.balanceValue === 0 ? dataUnlimited : [ percentageHelper(convertSecondsToMinutes(item.value), convertSecondsToMinutes(item.balanceValue)), 100],
        excludingSubscription: excludingSubscriptionMoreZero(excludingSub),
        overSpent: convertCentsToEuros(item.overspentValue ?? 0),
        unlimited: item.balanceValue === 0,
        base: item,
        included: productStore?.volume?.voice ?? 0,
        options: productStore?.volumeOptions?.voice ?? 0
    }
}

const consumedSms = (item: UnitValueBalance): IConsumedType => {
    const productStore = getProductStore();
    const excludingSub = item.value-item.balanceValue;

    return {
        consumed: item.value,
        backgroundColor: [ConsumptionDataColorEnum.SMS, ConsumptionDataColorEnum.NEUTRE],
        data:  item.balanceValue === 0 ? dataUnlimited : [ item.value, 100],
        excludingSubscription: excludingSubscriptionMoreZero(excludingSub),
        overSpent: convertCentsToEuros(item.overspentValue ?? 0),
        unlimited: item.balanceValue === 0,
        base: item,
        included: productStore?.volume?.sms ?? 0,
        options: productStore?.volumeOptions?.sms ?? 0
    }
}

const excludingSubscriptionMoreZero = (excludingSub: number): number | null => {
    return excludingSub > 0 ? Number.parseFloat(excludingSub.toFixed(2)) : null;
}

// eslint-disable-next-line
const consumedList: any = {
    [ConsumptionSummaryTypeEnum.DATA]: consumedData,
    [ConsumptionSummaryTypeEnum.CALL]: consumedCall,
    [ConsumptionSummaryTypeEnum.SMS]: consumedSms
};

export const consumptionDataConstruction = (item: UnitValueBalance | null, type: ConsumptionSummaryTypeEnum | null): IConsumedType | null  => {
    if(!item || !type) {
        return null;
    }
    
    return consumedList[type](item) || null;
}
